'use client'

import cn from 'clsx'
import { useEffect, useRef, useState } from 'react'
import s from './pricing.module.css'

export function Tabs({ activeTab, setActiveTab, className }) {
  const yearlyRef = useRef(null)
  const monthlyRef = useRef(null)
  const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 })

  useEffect(() => {
    let frameId = null

    const update = () => {
      const currentTab =
        activeTab === 0 ? yearlyRef.current : monthlyRef.current
      if (currentTab) {
        const { offsetLeft, offsetWidth } = currentTab
        setHighlightStyle({ left: offsetLeft, width: offsetWidth })
      }
    }

    const handleResize = () => {
      if (frameId) return
      frameId = requestAnimationFrame(() => {
        update()
        frameId = null
      })
    }

    update()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      if (frameId) cancelAnimationFrame(frameId)
    }
  }, [activeTab])

  return (
    <div
      className={cn(
        s.tabs,
        'relative flex dr-gap-6 dr-p-4 dr-rounded-9999',
        className
      )}
    >
      <span
        className="absolute dr-top-4 dr-bottom-4 dr-rounded-9999 bg-white transition-all duration-300 z-0"
        style={{
          left: highlightStyle.left,
          width: highlightStyle.width,
        }}
      />
      <button
        ref={yearlyRef}
        type="button"
        onClick={() => setActiveTab(0)}
        className={cn(
          'h6 relative transition-colors duration-300 dr-py-10 dt:dr-py-4 dr-px-12 dt:dr-px-10 cursor-pointer',
          activeTab === 0 ? 'text-black' : 'text-white hover:text-black'
        )}
      >
        Yearly (save 20%)
      </button>
      <button
        ref={monthlyRef}
        type="button"
        onClick={() => setActiveTab(1)}
        className={cn(
          'h6 relative transition-colors duration-300 dr-py-10 dt:dr-py-4 dr-px-12 dt:dr-px-10 cursor-pointer',
          activeTab === 1 ? 'text-black' : 'text-white hover:text-black'
        )}
      >
        Monthly
      </button>
    </div>
  )
}
